import { ListingSellerModel } from '@steelbuy/ts-shared';

import { ListingSellerEntityData } from './ListingSellerEntityData';
import { useEntityData } from '../../util/consumer/EntityConsumerHook';

export const useListingSellerEntityData = () => useEntityData<ListingSellerModel>(ListingSellerEntityData);
